import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from "react-router-dom";
import { useRequest, useAuth } from '../../../hooks';
import { apiRoutes } from "../../../api";
import VersionApp from "../../version-app";
import { jwtDecode } from 'jwt-decode';

import { useAuth0 } from '@auth0/auth0-react';



const LoginForm = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showMsgError, setShowMsgError] = useState(false);
  const [loginFn, { data, error: errorLogin, isLoading }] = useRequest({
    url: apiRoutes.LOGIN,
    method: 'POST',
  });

  const { 
    register, 
    handleSubmit, 
    formState: { errors }
  } = useForm();

  const onSubmit = (data) => {
    const { userName, password } = data;
    loginFn({ correo: userName, contrasenia: password })
  }
  
  const { isAuthenticated, getIdTokenClaims, user, isLoading: auth0Loading } = useAuth0();

  useEffect(() => {
    const handleAuth0Token = async () => {
      if (isAuthenticated && !auth0Loading) {
        try {
          const idTokenClaims = await getIdTokenClaims();
          if (idTokenClaims && idTokenClaims.__raw) {
            const auth0Token = idTokenClaims.__raw;
            const decodedToken = jwtDecode(auth0Token);
            const perfil = decodedToken.perfil?.toUpperCase();

            login({ idToken: auth0Token, perfil: perfil });
            
            // Redirigir según el perfil
            setTimeout(() => {
              if (perfil === 'ADMINISTRADOR' || perfil === 'CONSULTA') {
                navigate("/agency/list");
              } else if (perfil === 'AGENCIAS' || perfil === 'AGENCIA') {
                navigate("/pnr/validate");
              }
            }, 200);
          }
        } catch (error) {
          console.error('Error al obtener token de Auth0:', error);
        }
      }
    };
    
    handleAuth0Token();
  }, [isAuthenticated, auth0Loading, getIdTokenClaims, user, login, navigate]);

  useEffect(() => {
    const rol = localStorage.getItem('@csi/rol');
    const token = localStorage.getItem('@csi/token');
    
    if (token) {
      if (rol === 'ADMINISTRADOR' || rol === 'CONSULTA') {
        navigate("/agency/list");
      } else if (rol === 'AGENCIAS') {
        navigate("/pnr/validate");
      }
    } else {
      localStorage.removeItem('@csi/rol');
      localStorage.removeItem('@csi/token');
    }
  }, [])

  useEffect(() => {
    if (data) {
      login(data);
      if (data.perfil === 'ADMINISTRADOR' || data.perfil === 'CONSULTA') {
        navigate("/agency/list");
      } else {
        navigate("/pnr/validate");
      }
    }
  }, [data]);

  useEffect(() => {
    if (errorLogin) {
      const { error: {response: { data }} } = errorLogin;
      if (data?.errorDetail && data.errorDetail[0] === "FORCE_CHANGE_PASSWORD") {
        navigate("/change/password");
      } else {
        setShowMsgError(true);
      }
    }
  }, [errorLogin]);
  
  const { loginWithRedirect } = useAuth0();
  return (
    <main className="form-signin w-100 h-100 m-auto d-flex justify-content-center align-items-center">
      <div className="wrapper m-auto form-card">
        <div className="card-title lightblue-bg mb-0 text-center py-4">
          <h1 className="h3" id="iniciar-sesion">Iniciar Sesión</h1>
        </div>
        <form id="loginform" onSubmit={handleSubmit(onSubmit)}>

                    <Button
            variant="success"
            size="lg"
            className={"text-uppercase mt-3 w-100"}
            onClick={() => loginWithRedirect()}
          >
            Iniciar sesión
          </Button>
          <VersionApp isLogin={true} />
        </form>
      </div>
    </main>
  );
}
export default LoginForm;
